(function () {
  'use strict';

  var FIRST_LOOK_PRODUCT_ID = '10539213357358';
  var DISMISS_KEY = 'plumeFreeGiftBarDismissed';
  var addInFlight = false;
  var normalizationPromise = null;
  var normalizationScheduled = false;
  var checkoutInFlight = false;

  function cartUrl(suffix) {
    var base = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
    return base + suffix;
  }

  function getCart() {
    return fetch(cartUrl('.js'), {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(parseResponse);
  }

  function parseResponse(response) {
    if (!response.ok) throw new Error('Cart request failed');
    return response.json();
  }

  function addLine(variantId) {
    var url = window.routes && window.routes.cartAddUrl
      ? window.routes.cartAddUrl + '.js'
      : '/cart/add.js';

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1,
          properties: { _free_gift: 'true' }
        }]
      })
    }).then(parseResponse);
  }

  function removeLineByKey(key) {
    var url = window.routes && window.routes.cartChangeUrl
      ? window.routes.cartChangeUrl + '.js'
      : '/cart/change.js';

    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(parseResponse);
  }

  function getGiftLines(cart, productId) {
    var lines = [];
    var items = cart && cart.items ? cart.items : [];

    for (var i = 0; i < items.length; i++) {
      if (String(items[i].product_id) === String(productId)) {
        lines.push(items[i]);
      }
    }

    return lines;
  }

  function cartHasFirstLook(cart) {
    return (cart && cart.items ? cart.items : []).some(function (item) {
      return String(item.product_id) === FIRST_LOOK_PRODUCT_ID && item.quantity > 0;
    });
  }

  function normalizeGiftQuantity(cart, productId) {
    if (cartHasFirstLook(cart)) return removeGiftLines(cart, productId);
    var giftLines = getGiftLines(cart, productId);
    var totalQuantity = 0;
    var updates = {};

    for (var i = 0; i < giftLines.length; i++) {
      totalQuantity += giftLines[i].quantity;
    }

    if (totalQuantity <= 1) {
      return Promise.resolve({ cart: cart, changed: false });
    }

    for (var j = 0; j < giftLines.length; j++) {
      updates[giftLines[j].key] = j === 0 ? 1 : 0;
    }

    return fetch(cartUrl('/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(parseResponse).then(function (updatedCart) {
      return { cart: updatedCart, changed: true };
    });
  }

  function removeGiftLines(cart, productId) {
    var giftLines = getGiftLines(cart, productId);
    var updates = {};

    if (giftLines.length === 0) {
      return Promise.resolve({ cart: cart, changed: false });
    }

    for (var i = 0; i < giftLines.length; i++) {
      updates[giftLines[i].key] = 0;
    }

    return fetch(cartUrl('/update.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(parseResponse).then(function (updatedCart) {
      if (getGiftLines(updatedCart, productId).length > 0) {
        throw new Error('Ineligible complimentary item remains in cart');
      }
      return { cart: updatedCart, changed: true };
    });
  }

  function getRenderedGiftState() {
    var giftLines = document.querySelectorAll('[data-free-gift-line]');
    var seenKeys = {};
    var productId = null;
    var totalQuantity = 0;
    var offerEnabled = true;

    for (var i = 0; i < giftLines.length; i++) {
      var key = giftLines[i].getAttribute('data-free-gift-line-key') || ('line-' + i);
      if (seenKeys[key]) continue;

      seenKeys[key] = true;
      productId = productId || giftLines[i].getAttribute('data-free-gift-product-id');
      totalQuantity += parseInt(giftLines[i].getAttribute('data-free-gift-line-quantity'), 10) || 0;
      if (giftLines[i].getAttribute('data-free-gift-offer-enabled') === '0') {
        offerEnabled = false;
      }
    }

    return {
      productId: productId,
      totalQuantity: totalQuantity,
      bundleInCart: !!document.querySelector('[data-first-look-bundle-line]'),
      offerEnabled: offerEnabled
    };
  }

  function announceLimit(message, state) {
    var notices = document.querySelectorAll('[data-free-gift-limit-status]');

    for (var i = 0; i < notices.length; i++) {
      notices[i].textContent = message || '';
      notices[i].hidden = !message;
      notices[i].setAttribute('data-state', state || 'info');
    }
  }

  function ensureGiftPolicy(productId, offerEnabled) {
    if (!productId) return Promise.resolve({ changed: false });
    if (normalizationPromise) return normalizationPromise;

    normalizationPromise = getCart()
      .then(function (cart) {
        return offerEnabled === false
          ? removeGiftLines(cart, productId)
          : normalizeGiftQuantity(cart, productId);
      })
      .then(function (result) {
        normalizationPromise = null;
        return result;
      }, function (error) {
        normalizationPromise = null;
        throw error;
      });

    return normalizationPromise;
  }

  function refreshCart() {
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (error) {
      softNavigate();
      return;
    }

    window.setTimeout(function () {
      var renderedState = getRenderedGiftState();
      var needsRefresh = renderedState.totalQuantity > 1 ||
        ((renderedState.offerEnabled === false || renderedState.bundleInCart) && renderedState.totalQuantity > 0);
      if (needsRefresh) softNavigate();
    }, 750);
  }

  function normalizeRenderedGiftLines(shouldRefresh) {
    var renderedState = getRenderedGiftState();
    if (!renderedState.productId) return Promise.resolve({ changed: false });

    if (renderedState.bundleInCart) {
      announceLimit('First Look already includes your pencil. Removing the extra…', 'working');
    } else if (renderedState.offerEnabled === false) {
      announceLimit('Removing the complimentary pencil while this promotion is paused…', 'working');
    } else if (renderedState.totalQuantity > 1) {
      announceLimit('Removing the extra complimentary pencil…', 'working');
    }

    return ensureGiftPolicy(renderedState.productId, renderedState.offerEnabled).then(function (result) {
      if (result.changed) {
        if (renderedState.bundleInCart) {
          announceLimit('Extra pencil removed. Your First Look bundle includes your pencil.', 'success');
        } else if (renderedState.offerEnabled === false) {
          announceLimit('Complimentary pencil removed while this promotion is paused.', 'success');
        } else {
          announceLimit('Extra complimentary pencil removed. Limit one per order.', 'success');
        }
        if (shouldRefresh) refreshCart();
      }
      return result;
    });
  }

  function scheduleRenderedNormalization() {
    if (normalizationScheduled) return;

    normalizationScheduled = true;
    window.setTimeout(function () {
      normalizationScheduled = false;

      var renderedState = getRenderedGiftState();
      var needsEnforcement = renderedState.totalQuantity > 1 ||
        ((renderedState.offerEnabled === false || renderedState.bundleInCart) && renderedState.totalQuantity > 0);
      if (needsEnforcement && !normalizationPromise) {
        normalizeRenderedGiftLines(true).catch(function () {
          announceLimit('We could not update the complimentary pencil. Please refresh your cart.', 'error');
        });
      }
    }, 0);
  }

  function observeCartChanges() {
    if (!window.MutationObserver || !document.body) return;

    var observer = new MutationObserver(scheduleRenderedNormalization);
    var cartSections = document.querySelectorAll('[data-section-type="cart"]');

    for (var i = 0; i < cartSections.length; i++) {
      observer.observe(cartSections[i], { childList: true, subtree: true });
    }
  }

  function setCheckoutBusy(isBusy) {
    var checkoutButtons = document.querySelectorAll('[name="checkout"]');

    for (var i = 0; i < checkoutButtons.length; i++) {
      if (isBusy) {
        if (!checkoutButtons[i].getAttribute('data-free-gift-original-label')) {
          checkoutButtons[i].setAttribute('data-free-gift-original-label', checkoutButtons[i].innerHTML);
        }
        checkoutButtons[i].setAttribute('disabled', 'disabled');
        checkoutButtons[i].textContent = 'Checking cart…';
      } else {
        var originalLabel = checkoutButtons[i].getAttribute('data-free-gift-original-label');
        if (originalLabel) checkoutButtons[i].innerHTML = originalLabel;
        checkoutButtons[i].removeAttribute('disabled');
      }
    }
  }

  function beginCheckout() {
    if (checkoutInFlight) return;

    var renderedState = getRenderedGiftState();
    if (!renderedState.productId) return;

    checkoutInFlight = true;
    setCheckoutBusy(true);
    if (renderedState.bundleInCart) {
      announceLimit('First Look already includes your pencil. Removing the extra…', 'working');
    } else if (renderedState.offerEnabled === false) {
      announceLimit('Removing the complimentary pencil while this promotion is paused…', 'working');
    } else {
      announceLimit('Checking the complimentary pencil limit…', 'working');
    }

    ensureGiftPolicy(renderedState.productId, renderedState.offerEnabled)
      .then(function (result) {
        if (result.changed && renderedState.offerEnabled === false) {
          announceLimit('Complimentary pencil removed. Continuing to checkout…', 'success');
        } else if (result.changed) {
          announceLimit('Extra complimentary pencil removed. Continuing to checkout…', 'success');
        }

        var checkoutUrl = window.routes && window.routes.checkoutUrl
          ? window.routes.checkoutUrl
          : '/checkout';
        window.location.assign(checkoutUrl);
      })
      .catch(function () {
        checkoutInFlight = false;
        setCheckoutBusy(false);
        announceLimit('We could not verify the gift quantity. Please refresh your cart and try again.', 'error');
      });
  }

  function handleCheckoutClick(event) {
    if (!event.target || !event.target.closest) return;

    var checkoutButton = event.target.closest('[name="checkout"]');
    if (checkoutButton && getRenderedGiftState().productId) {
      event.preventDefault();
      event.stopImmediatePropagation();
      beginCheckout();
      return;
    }

    var acceleratedCheckout = event.target.closest('.Cart__AcceleratedCheckout');
    var renderedState = getRenderedGiftState();

    var acceleratedCheckoutNeedsEnforcement = renderedState.totalQuantity > 1 ||
      ((renderedState.offerEnabled === false || renderedState.bundleInCart) && renderedState.totalQuantity > 0);

    if (acceleratedCheckout && acceleratedCheckoutNeedsEnforcement) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (renderedState.offerEnabled === false) {
        announceLimit('Removing the paused complimentary pencil before express checkout…', 'working');
      } else {
        announceLimit('Removing the extra complimentary pencil before express checkout…', 'working');
      }
      normalizeRenderedGiftLines(true).catch(function () {
        announceLimit('Please refresh your cart before continuing to checkout.', 'error');
      });
    }
  }

  function handleCheckoutSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.Cart')) return;
    if (!getRenderedGiftState().productId) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    beginCheckout();
  }

  function getSelectedVariantId(blockEl) {
    var checked = blockEl.querySelector('[data-free-gift-variant]:checked:not(:disabled)');
    if (checked) return checked.value;
    var firstAvailable = blockEl.querySelector('[data-free-gift-variant]:not(:disabled)');
    return firstAvailable ? firstAvailable.value : null;
  }

  function openCartDrawer() {
    var existingTrigger = document.querySelector(
      '[data-drawer-id="sidebar-cart"][data-action="open-drawer"]'
    );
    if (existingTrigger) {
      existingTrigger.click();
      return true;
    }
    if (window.theme && typeof window.theme.openDrawer === 'function') {
      window.theme.openDrawer('sidebar-cart');
      return true;
    }
    return false;
  }

  function safeGetDismissed() {
    try { return sessionStorage.getItem(DISMISS_KEY) === '1'; }
    catch (e) { return false; }
  }
  function safeSetDismissed() {
    try { sessionStorage.setItem(DISMISS_KEY, '1'); }
    catch (e) { /* noop */ }
  }
  function applyDismissedStateToBars() {
    if (!safeGetDismissed()) return;
    var bars = document.querySelectorAll('.FreeGiftPromoBar[data-dismissible="1"]');
    for (var i = 0; i < bars.length; i++) {
      bars[i].style.display = 'none';
    }
  }

  // ──────────────────────────────────────────────────────────────────
  // Goto navigation (GET, no POST resubmit prompt)
  // ──────────────────────────────────────────────────────────────────
  function softNavigate() {
    window.location.assign(window.location.pathname + window.location.search + window.location.hash);
  }

  // ──────────────────────────────────────────────────────────────────
  // Single delegated click handler
  // ──────────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    // Promo bar dismiss
    var dismissBtn = e.target.closest('[data-action="dismiss-free-gift-bar"]');
    if (dismissBtn) {
      e.preventDefault();
      e.stopPropagation();
      var bar = dismissBtn.closest('.FreeGiftPromoBar');
      if (bar) bar.style.display = 'none';
      safeSetDismissed();
      return;
    }

    // Promo bar / banner "open cart drawer" links
    var drawerOpenLink = e.target.closest('[data-free-gift-open-cart]');
    if (drawerOpenLink) {
      // Only consume the click if we can actually open the drawer.
      // If not (cart_type set to "Page", drawer selectors differ, JS error),
      // let the link's href="/cart" do its natural thing.
      if (openCartDrawer()) {
        e.preventDefault();
      }
      return;
    }

    // Cart drawer Add / Remove buttons
    var blockEl = e.target.closest('[data-free-gift-block]');
    if (!blockEl) return;

    var addBtn = e.target.closest('[data-free-gift-add]');
    var removeBtn = e.target.closest('[data-free-gift-remove]');

    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (addInFlight) return;

      var variantId = getSelectedVariantId(blockEl);
      if (!variantId) return;
      var productId = blockEl.getAttribute('data-product-id');
      if (!productId) return;

      addInFlight = true;
      addBtn.setAttribute('disabled', 'disabled');
      var originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      getCart()
        .then(function (cart) {
          var giftLines = getGiftLines(cart, productId);

          if (cartHasFirstLook(cart) || giftLines.length > 0) {
            return normalizeGiftQuantity(cart, productId);
          }

          return addLine(variantId)
            .then(getCart)
            .then(function (updatedCart) {
              return normalizeGiftQuantity(updatedCart, productId);
            });
        })
        .then(function () { softNavigate(); })
        .catch(function () {
          addInFlight = false;
          addBtn.removeAttribute('disabled');
          addBtn.textContent = originalLabel;
        });
      return;
    }

    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var key = blockEl.getAttribute('data-gift-line-key');
      if (!key) return;
      removeBtn.setAttribute('disabled', 'disabled');
      removeLineByKey(key)
        .then(function () { softNavigate(); })
        .catch(function () { removeBtn.removeAttribute('disabled'); });
      return;
    }
  });

  document.addEventListener('click', handleCheckoutClick, true);
  document.addEventListener('submit', handleCheckoutSubmit, true);

  function init() {
    applyDismissedStateToBars();
    normalizeRenderedGiftLines(true).catch(function () {});
    observeCartChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
